/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    EssentialName: {
        id: 'qnb.spt.SingleTripExcessesModal.EssentialName',
        defaultMessage: 'Essential'
    },
    StandardPlusName: {
        id: 'qnb.spt.SingleTripExcessesModal.StandardName',
        defaultMessage: 'Standard/Plus'
    },
    Standard: {
        id: 'qnb.spt.SingleTripExcessesModal.Standard',
        defaultMessage: 'Standard'
    },
    PlusName: {
        id: 'qnb.spt.SingleTripExcessesModal.PlusName',
        defaultMessage: 'Plus'
    },
    CancellationName: {
        id: 'qnb.spt.SingleTripExcessesModal.CancellationName',
        defaultMessage: 'Cancellation cover'
    },
    CancellationEssentialAmount: {
        id: 'qnb.spt.SingleTripExcessesModal.CancellationEssentialAmount',
        defaultMessage: '£150'
    },
    CancellationStandardPlusAmount: {
        id: 'qnb.spt.SingleTripExcessesModal.CancellationStandardPlusAmount',
        defaultMessage: '£{excessInput}'
    },
    MedicalExpensesName: {
        id: 'qnb.spt.SingleTripExcessesModal.MedicalExpensesName',
        defaultMessage: 'Medical and associated expenses'
    },
    MedicalExpensesEssentialValue: {
        id: 'qnb.spt.SingleTripExcessesModal.MedicalExpensesEssentialValue',
        defaultMessage: '£150'
    },
    MedicalExpensesStandardPlusValue: {
        id: 'qnb.spt.SingleTripExcessesModal.MedicalExpensesPlusValue',
        defaultMessage: '£{excessInput}'
    },
    LostStolenBaggageName: {
        id: 'qnb.spt.SingleTripExcessesModal.LostStolenBaggageName',
        defaultMessage: 'Lost, stolen or damaged baggage'
    },
    LostStolenBaggageEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.LostStolenBaggageEssential',
        defaultMessage: '£150'
    },
    LostStolenBaggageStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.LostStolenBaggagePlus',
        defaultMessage: '£{excessInput}'
    },
    HospitalBenefitName: {
        id: 'qnb.spt.SingleTripExcessesModal.HospitalBenefitName',
        defaultMessage: 'Hospital benefit'
    },
    HospitalBenefitEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.HospitalBenefitEssential',
        defaultMessage: 'Not included'
    },
    HospitalBenefitStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.HospitalBenefitPlus',
        defaultMessage: 'Nil'
    },
    DelayedBaggageName: {
        id: 'qnb.spt.SingleTripExcessesModal.DelayedBaggageName',
        defaultMessage: 'Delayed baggage'
    },
    DelayedBaggageEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.DelayedBaggageEssential',
        defaultMessage: 'Not included'
    },
    DelayedBaggageStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.DelayedBaggagePlus',
        defaultMessage: 'Nil'
    },
    DelayedFlightAssistanceName: {
        id: 'qnb.spt.SingleTripExcessesModal.DelayedFlightAssistanceName',
        defaultMessage: 'Delayed flight assistance'
    },
    DelayedFlightAssistanceEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.DelayedFlightAssistanceEssential',
        defaultMessage: 'Not included'
    },
    DelayedFlightAssistanceStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.DelayedFlightAssistancePlus',
        defaultMessage: 'Nil'
    },
    MissedDepartureName: {
        id: 'qnb.spt.SingleTripExcessesModal.MissedDepartureName',
        defaultMessage: 'Missed departure'
    },
    MissedDepartureEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.MissedDepartureEssential',
        defaultMessage: 'Not included'
    },
    MissedDepartureStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.MissedDeparturePlus',
        defaultMessage: 'Nil'
    },
    DelayedDepartureName: {
        id: 'qnb.spt.SingleTripExcessesModal.DelayedDepartureName',
        defaultMessage: 'Delayed departure'
    },
    DelayedDepartureEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.DelayedDepartureEssential',
        defaultMessage: 'Nil'
    },
    DelayedDepartureStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.DelayedDeparturePlus',
        defaultMessage: 'Nil'
    },
    AbandonmentName: {
        id: 'qnb.spt.SingleTripExcessesModal.AbandonmentName',
        defaultMessage: 'Abandonment'
    },
    AbandonmentEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.AbandonmentEssential',
        defaultMessage: '£150'
    },
    AbandonmentStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.AbandonmentPlus',
        defaultMessage: '£{excessInput}'
    },
    PersonalAccidentName: {
        id: 'qnb.spt.SingleTripExcessesModal.PersonalAccidentName',
        defaultMessage: 'Personal accident'
    },
    PersonalAccidentEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.PersonalAccidentEssential',
        defaultMessage: 'Not included'
    },
    PersonalAccidentStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.PersonalAccidentPlus',
        defaultMessage: 'Nil'
    },
    CriminalInjuryName: {
        id: 'qnb.spt.SingleTripExcessesModal.CriminalInjuryName',
        defaultMessage: 'Criminal injury benefit'
    },
    CriminalInjuryEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.CriminalInjuryEssential',
        defaultMessage: 'Not included'
    },
    CriminalInjuryStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.CriminalInjuryPlus',
        defaultMessage: 'Nil'
    },
    SubstituteAccommodationName: {
        id: 'qnb.spt.SingleTripExcessesModal.SubstituteAccommodationName',
        defaultMessage: 'Substitute accommodation'
    },
    SubstituteAccommodationEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.SubstituteAccommodationEssential',
        defaultMessage: 'Not included'
    },
    SubstituteAccommodationStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.SubstituteAccommodationPlus',
        defaultMessage: '£{excessInput}'
    },
    EnforcedStayName: {
        id: 'qnb.spt.SingleTripExcessesModal.EnforcedStayName',
        defaultMessage: 'Enforced stay'
    },
    EnforcedStayEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.EnforcedStayEssential',
        defaultMessage: 'Not included'
    },
    EnforcedStayStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.EnforcedStayPlus',
        defaultMessage: '£{excessInput}'
    },
    PassportLossName: {
        id: 'qnb.spt.SingleTripExcessesModal.PassportLossName',
        defaultMessage: 'Loss of passport'
    },
    PassportLossEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.PassportLossEssential',
        defaultMessage: 'Nil'
    },
    PassportLossStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.PassportLossPlus',
        defaultMessage: 'Nil'
    },
    PersonalMoneyName: {
        id: 'qnb.spt.SingleTripExcessesModal.PersonalMoneyName',
        defaultMessage: 'Personal money'
    },
    PersonalMoneyEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.PersonalMoneyEssential',
        defaultMessage: '£150'
    },
    PersonalMoneyStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.PersonalMoneyPlus',
        defaultMessage: '£{excessInput}'
    },
    ReplacementFlightName: {
        id: 'qnb.spt.SingleTripExcessesModal.ReplacementFlightName',
        defaultMessage: 'Replacement flight'
    },
    ReplacementFlightEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.ReplacementFlightEssential',
        defaultMessage: '£1,500'
    },
    ReplacementFlightStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.ReplacementFlightPlus',
        defaultMessage: '£1,500'
    },
    PetCareName: {
        id: 'qnb.spt.SingleTripExcessesModal.PetCareName',
        defaultMessage: 'Pet care'
    },
    PetCareEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.PetCareEssential',
        defaultMessage: 'Not included'
    },
    PetCareStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.PetCarePlus',
        defaultMessage: 'Nil'
    },
    HijackMuggingName: {
        id: 'qnb.spt.SingleTripExcessesModal.HijackMuggingName',
        defaultMessage: 'Hijack and mugging'
    },
    HijackMuggingEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.HijackMuggingEssential',
        defaultMessage: 'Nil'
    },
    HijackMuggingStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.HijackMuggingPlus',
        defaultMessage: 'Nil'
    },
    AirRageName: {
        id: 'qnb.spt.SingleTripExcessesModal.AirRageName',
        defaultMessage: 'Air rage'
    },
    AirRageEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.AirRageEssential',
        defaultMessage: 'Not included'
    },
    AirRageStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.AirRagePlus',
        defaultMessage: 'Nil'
    },
    PersonalLiabilityName: {
        id: 'qnb.spt.SingleTripExcessesModal.PersonalLiabilityName',
        defaultMessage: 'Personal liability'
    },
    PersonalLiabilityEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.PersonalLiabilityEssential',
        defaultMessage: 'Nil'
    },
    PersonalLiabilityStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.PersonalLiabilityPlus',
        defaultMessage: 'Nil'
    },
    LegalExpensesName: {
        id: 'qnb.spt.SingleTripExcessesModal.LegalExpensesName',
        defaultMessage: 'Legal expenses and advice'
    },
    LegalExpensesEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.LegalExpensesEssential',
        defaultMessage: 'Nil'
    },
    LegalExpensesStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.LegalExpensesPlus',
        defaultMessage: 'Nil'
    },
    CruiseMissedPortName: {
        id: 'qnb.spt.SingleTripExcessesModal.CruiseMissedPortName',
        defaultMessage: 'Cruise - Missed port*'
    },
    CruiseMissedPortEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.CruiseMissedPortEssential',
        defaultMessage: 'Not included'
    },
    CruiseMissedPortStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.CruiseMissedPortPlus',
        defaultMessage: 'Nil'
    },
    CruiseRejoinName: {
        id: 'qnb.spt.SingleTripExcessesModal.CruiseRejoinName',
        defaultMessage: 'Cruise - Interruption*'
    },
    CruiseRejoinEssential: {
        id: 'qnb.spt.SingleTripExcessesModal.CruiseRejoinEssential',
        defaultMessage: 'Not included'
    },
    CruiseRejoinStandardPlus: {
        id: 'qnb.spt.SingleTripExcessesModal.CruiseRejoinPlus',
        defaultMessage: '£{excessInput}'
    },
    CruiseBenefits: {
        id: 'qnb.spt.SingleTripExcessesModal.CruiseBenefits',
        defaultMessage: '*Cruise benefits apply to Plus cover only'
    },
    PerClaim: {
        id: 'qnb.spt.SingleTripExcessesModal.PerClaim',
        defaultMessage: 'Per claim'
    },
    Excesses: {
        id: 'qnb.spt.SingleTripExcessesModal.Excesses',
        defaultMessage: 'Excesses'
    },
    ModalMessageClose: {
        id: 'qnb.spt.SingleTripExcessesModal.ModalMessageClose',
        defaultMessage: 'Close'
    },
});
